import React, { CSSProperties } from 'react';

interface CurrentStepIconProps {
  style?: CSSProperties;
  width?: number;
  height?: number;
}

const CurrentStepIcon: React.FC<CurrentStepIconProps> = ({ style, width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <circle cx="6.99988" cy="6.8363" r="4.8363" fill="#8DA6FF" stroke="#4F55FD" strokeWidth="4" />
  </svg>
);

export default CurrentStepIcon;
